import { Grid, Typography } from "@mui/material";
import { CircularLoaderFullPage } from "components/core";
import dayjs from "dayjs";
import MUIDataTable from "mui-datatables";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectAuth } from "store/slices";
import spacing from "styles/spacing";
import { DEFAULT_DATA_TABLE_OPTIONS, localeDateFormatWithTime, numberConstants } from "utils/constants";
import { tableRowChange } from "utils/constants/employee/EmployeeDetailConstant";
import { personalHistoryCol, sortDirectionConst } from "utils/constants/personnel/personnelConstans";
import { personnelDetailStyles } from "./PersonnelDetailStyles";

const PersonnelHistoryTable = ({
  isResetGrid,
  isLoading,
  historyData,
  handleChangePage,
  totalRecords,
  personalHistoryForm,
  handlePageRowsChange,
  handleColumnSort,
  handleFilterValueChange,
  firstName,
  lastName,
  rowsPerPage,
  allCustomerList
}) => {
  const { t } = useTranslation();
  const { localeByBranch } = useSelector(selectAuth);
  const personnalName = `${lastName}, ${firstName}`;
  //Table Options

  const options = {
    ...DEFAULT_DATA_TABLE_OPTIONS,
    download: true,
    search: true,
    filter: true,
    viewColumns: true,
    onChangePage: ((number) => {
      handleChangePage(number);
    }),
    onTableChange: ((action, tState) => {
      if (action === tableRowChange) {
        handlePageRowsChange(tState.rowsPerPage, tState.page);
      }
    }),
    onColumnSortChange: ((column, sort) => {
      const sortProperty = personalHistoryCol[column];
      const sortDirection = sortDirectionConst[sort];
      handleColumnSort(sortProperty, sortDirection);
    }),
    onFilterChange: ((changedColumn, filterList, type, changedColumnIndex, displayData) => {
      const filterValue = filterList[changedColumnIndex]?.[0];
      let customerNumber = numberConstants.minusOne;
      if (filterValue !== undefined) {
        customerNumber = filterValue === '' ? `${numberConstants.zero}     ` : filterValue;
      }
      handleFilterValueChange(customerNumber);
    }),
    count: totalRecords,
    pagination: true,
    serverSide: true,
    rowsPerPageOptions: [12, 25, 50, 100],
    rowsPerPage: rowsPerPage,
    textLabels: {
      body: {
        noMatch:
          totalRecords === numberConstants.zero &&
          (!isResetGrid
            ? `${t("common.noDataFound")}`
            : `${t("common.tableTextWithoutInputs")}`)
      }
    },
    selectableRowsOnClick: true
  };


  const columns = [
    {
      name: "change_datetime",
      label: t("personalHistory.date"),
      options: {
        customBodyRender: (value) => {
          const formattedDate = value
            ? dayjs
              .utc(value)
              .locale(localeByBranch)
              .format(localeDateFormatWithTime)
            : "";
          return formattedDate;
        },
        filter: false // Disable filter for this column
      }
    },
    {
      name: "customer_number",
      label: t("personalHistory.customer"),
      options: {
        sortFilterList: false,
        sort: false,
        filter: true, // Disable filter for this column
        filterOptions: {
          fullWidth: true,
          names: allCustomerList
        }
      }
    },
    {
      name: "attribute_name",
      label: t("personalHistory.details"),
      options: {
        customBodyRender: (value, tableMeta) => {
          const colValue = tableMeta.tableData[tableMeta.rowIndex];
          const displayValue = colValue.attribute_name ? colValue.attribute_name : colValue.change_history_type_description;
          return displayValue;
        },
        filter: false // Disable filter for this column
      }
    },
    {
      name: "old_value",
      label: t("personalHistory.previousValue"),
      options: {
        filter: false // Disable filter for this column
      }
    },
    {
      name: "new_value",
      label: t("personalHistory.newValue"),
      options: {
        filter: false // Disable filter for this column
      }
    },
    {
      name: "authorized",
      label: t("personalHistory.authorizedPersonnel"),
      options: {
        customBodyRender: (value, tableMeta) => {
          const colValue = tableMeta.tableData[tableMeta.rowIndex];
          if (colValue.personnel_first_name) {
            return `${colValue.personnel_first_name}, ${colValue.personnel_last_name}`;
          }
          return '';
        },
        filter: false // Disable filter for this column
      }
    },
    {
      name: "employee_first_name",
      label: t("personalHistory.imEmployee"),
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return `${value}`;
        },
        filter: false // Disable filter for this column
      }
    },
    {
      name: "reason",
      label: t("personalHistory.byePassReason"),
      options: {
        filter: false // Disable filter for this column
      }
    }
  ];
  return (
    <>
      {isLoading && <CircularLoaderFullPage loading={isLoading} />}

      <Grid
        display={"flex"}
        direction={"column"}
        gap={spacing.verticalMargin20}
      >
        <Grid item xs={12} lg={3} marginTop={spacing.margingTop20}>
          <h3>
            {t("personalHistory.personnelHistoryTitle", {
              name: personnalName
            })}
          </h3>
        </Grid>
        <Grid item xs={12} lg={3}>
          <MUIDataTable
            columns={columns}
            options={options}
            sx={
              personnelDetailStyles.personalHistoryStyles
                .historyTableFilterStyles
            }
            data={historyData}
            title={
              !isResetGrid ? (
                <Typography>
                  {totalRecords} {t("common.recordsFound")}
                </Typography>
              ) : (
                ""
              )
            }
          />
        </Grid>
      </Grid>
    </>
  );
};
export default PersonnelHistoryTable;
